// extracted by mini-css-extract-plugin
module.exports = {"terms":"TermsList_terms__he231","terms__title":"TermsList_terms__title__kLAPO","terms__items":"TermsList_terms__items__JqkAN"};